import { FC } from "react";
import { UserAvatar } from "@promptlayer/ui";

import { cn } from "@/lib/utils";

interface UserAttributionProps {
  email: string | null | undefined;
  className?: string;
}

const UserAttribution: FC<UserAttributionProps> = ({ email, className }) => {
  if (!email) {
    return <span className="text-gray-300">&ndash;</span>;
  }

  return (
    <div className={cn("flex items-center gap-1.5 truncate", className)}>
      <UserAvatar email={email} className="h-4 w-4 flex-shrink-0 text-[8px]" />
      <span className="truncate text-xs text-gray-600">{email}</span>
    </div>
  );
};

export default UserAttribution;
